import { render, staticRenderFns } from "./detailRole.vue?vue&type=template&id=b9212dc0"
import script from "./detailRole.vue?vue&type=script&lang=js"
export * from "./detailRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports